// React
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

// FutureLab
import { store } from '../ReduxRoot';
import { chatItemInFocus } from '../actions/chatItemInFocusActions';
import { loggedInUserDetails } from '../actions/loggedInUserDetailsActions';
import { userListDetails } from '../actions/userListDetailsActions';
import { ChatParticipantsInterface } from '../components/chat/ChatListItemsDesktop';
import { userApi } from '../store/api/userApi';
import { useLazyGetUserDetailsListQuery } from '../store/api/userApi';
import { useLazyGetChatDetailsQuery } from '../store/api/chatApi';
import { getMissingUserIds } from '../utilities/UserDetails';
import { ChatPage } from './ChatPage';
import { ChatRoomPage } from './ChatRoomPage';

// 3rd Party
export function ChatRedirectPage() {
	const { chatId } = useParams();
	const hasFetched = useRef(false);
	const [isReady, setIsReady] = useState(false);
	const [loadChatDetails] = useLazyGetChatDetailsQuery();
	const [loadUserDetailsList] = useLazyGetUserDetailsListQuery();

	useEffect(() => {
		if (hasFetched.current) {
			return;
		}
		hasFetched.current = true;

		const fetchData = async () => {
			const currentUser = await store.dispatch(userApi.endpoints.getCurrentUser.initiate()).unwrap();
			store.dispatch(loggedInUserDetails(currentUser));

			if (chatId) {
				// Fetch chat details
				const chat = await loadChatDetails(chatId).unwrap();
				store.dispatch(chatItemInFocus(chat));
			}

			// Extract the user IDs of chat participants
			const chatParticipantsUserId = (store.getState().chatInFocus?.participants ?? []).map(
				(participant: ChatParticipantsInterface) => participant.userId
			);

			const missingUserIds = getMissingUserIds(
				chatParticipantsUserId,
				store.getState().userListProfilesDetails
			);
			if (missingUserIds.length > 0) {
				const users = await loadUserDetailsList(missingUserIds).unwrap();
				store.dispatch(userListDetails(users));
			}

			setIsReady(true);
		};

		fetchData();
	}, [loadChatDetails, loadUserDetailsList, chatId]);

	if (!isReady) {
		return <div></div>;
	}

	return (
		<div className="w-full min-w-0">
			<div className="chat-mobile-only w-full">
				<ChatRoomPage />
			</div>
			<div className="chat-desktop-only w-full">
				<ChatPage />
			</div>
		</div>
	);
}
